export const presentError = async (ctx, message) => ctx.$ionic.alertController
  .create({
    header: 'Fehler',
    message,
    buttons: ['OK'],
  })
  .then((a) => a.present());

export const presentMessage = async (ctx, header, message) => ctx.$ionic.alertController
  .create({
    header,
    message,
    buttons: ['OK'],
  })
  .then((a) => a.present());

export const presentQuestion = async (ctx, header, message) => new Promise(
  (resolve) => ctx.$ionic.alertController
    .create({
      header,
      message,
      buttons: [
        {
          text: 'Ja',
          handler: () => resolve(true),
        },
        {
          text: 'Nein',
          handler: () => resolve(false),
        },
      ],
    })
    .then((a) => a.present()),
);

export default {
  presentQuestion,
  presentError,
  presentMessage,
};
